<script setup lang="ts">
import { useBaseStore } from "@/stores/base";
import { computed, ref } from "vue";

const invalidPermissions = computed(() => {
	return useBaseStore().showInvalidPermissions;
});

const resetError = () => {
	useBaseStore().showInvalidPermissions = null;
};

const mockVisible = ref(true);
</script>

<template>
	<v-dialog v-model="mockVisible" persistent width="600">
		<v-card
			class="help"
			prepend-icon="fa: fa-duotone fa-shield-halved"
			title="403 Forbidden"
			color="error"
			variant="flat"
		>
			<v-divider />
			<div class="pa-5 pb-0">
				<div class="pb-2">
					{{ invalidPermissions.message }}
				</div>
			</div>
			<v-divider />
			<v-card-actions>
				<v-spacer />
				<v-btn color="white" variant="text" @click="resetError">Close</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<style scoped lang="scss"></style>
